import React, { Suspense } from "react"

import SnackbarWrapper from "organisms/common/SnackbarWrapper"

import InformationWrapper from "organisms/common/InformationWrapper"
import Header from "organisms/common/Header"
import Footer from "organisms/common/Footer"
import Loading from "organisms/common/Loading"

import useDAuth from "hooks/useDAuth"
import useApiLoading from "hooks/useApiLoading"
import APILoading from "organisms/common/APILoading"

const DefaultTemplate = ({ children }) => {
  const { isAuthLoading } = useDAuth()
  const { isApiLoading } = useApiLoading()

  return (
    <div>
      <InformationWrapper />
      <Header />
      <Suspense fallback={<Loading />}>
        {isAuthLoading ? <Loading /> : children}
      </Suspense>
      {isApiLoading ? <APILoading /> : null}
      <SnackbarWrapper />
      <Footer />
    </div>
  )
}

export default DefaultTemplate
